import {
  TENANT_ROLE_ADMIN,
  TENANT_ROLE_COMPANY_SUPERUSER,
  TENANT_ROLE_TEAM_LEADER,
} from '@/services/enumService';

export {
  TENANT_ROLE_ADMIN,
  TENANT_ROLE_COMPANY_SUPERUSER,
  TENANT_ROLE_TEAM_LEADER,
};

function normalizeRole(role) {
  return typeof role === 'string' ? role.trim() : '';
}

export function getUserRoles(user) {
  return Array.isArray(user?.roles) ? user.roles.map(normalizeRole).filter(Boolean) : [];
}

export function userHasAnyRole(user, requiredRoles) {
  const roles = new Set(getUserRoles(user));
  return (requiredRoles || []).some((role) => roles.has(normalizeRole(role)));
}

export function userHasRole(user, role) {
  return userHasAnyRole(user, [role]);
}

export function userIsTenantAdmin(user) {
  return userHasRole(user, TENANT_ROLE_ADMIN);
}

export function userIsCompanySuperuser(user) {
  return userHasRole(user, TENANT_ROLE_COMPANY_SUPERUSER);
}

export function userIsTeamLeader(user) {
  return userHasRole(user, TENANT_ROLE_TEAM_LEADER);
}
